export const convertToSwedishMaterialName = (material: string | undefined) => {
    if (material) {
        switch (material) {
            case 'ZIRCONIA':
                return 'Zirkonia';
            case 'EMAX':
                return 'Lithium Disilicate';
            case 'EMPRESS':
                return 'Empress';
            case 'PRESS_CERAMIC':
                return 'Presskeram';
            case 'PFM_COCR':
                return 'MK CoCr';
            case 'COCR_ACRYLIC':
                return 'CoCr/Akryl';
            case 'COCR_PORCELAIN':
                return 'CoCr/Porslin';
            case 'COCR_COMPOSITE':
                return 'CoCr/Porslin';
            case 'ACRYLATE':
                return 'Akrylat';
            case 'COMPOSITE':
                return 'Komposit';
            case 'MK_TITANIUM':
                return 'MK Titan';
            case 'MK_GOLD':
                return 'MK Guld';
            case 'COCR':
                return 'COCR';
            case 'GOLD':
                return 'Guld';
            case 'VALPLAST':
                return 'Valplast';
            case 'THERMOPLAST':
                return 'Thermoplast';
            default:
                return material;
        }
    }
    return '';
};
